import { Link } from "react-router-dom";
import logo from "../../assets/logo.png"; // Ensure the correct path to the logo
import footerRightDesign from "../../assets/footer-design-right.png"; // Ensure the correct path
import f6sLogoWhite from "../../assets/F6S-logo-preferred1.png";
import f6sNetworkPartnerWhite from "../../assets/F6S-network-partner-white.svg";
import { FaPhoneAlt, FaMapMarkerAlt, FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
  const handleLinkClick = () => {
    window.scrollTo(0, 0); // Scroll to the top when a link is clicked
  };

  return (
    <footer
      className="relative text-white py-12 bg-cover bg-center overflow-hidden"
      style={{ backgroundImage: "url('/footer-bg.png')" }} // Ensure the correct path
    >
      {/* Overlay for better contrast */}
      <div className="absolute inset-0 bg-black/30"></div>

      {/* Right Decorative Image */}
      <img
        src={footerRightDesign}
        alt="Footer Right Design"
        className="absolute top-28 right-0 w-1/3 h-full object-cover opacity-30 hidden md:block"
      />

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        {/* Logo & Navigation */}
        <div className="flex flex-col md:flex-row items-center justify-between border-white/20 pb-4 text-center md:text-left">
          {/* Logo */}
          <h1 className="text-[#02C4A1] text-xl font-bold flex items-center mb-4 md:mb-0">
            <img src={logo} alt="Logo" className="h-5 mr-2" />
          </h1>

          {/* Navigation Links */}
          <div className="flex flex-wrap justify-center md:justify-end gap-4 md:space-x-3 text-gray-300 text-sm">
            <Link to="/about" onClick={handleLinkClick}>About Us</Link>
            <Link to="/startup" onClick={handleLinkClick}>Startup Accelerator</Link>
            <Link to="/startup-studio" onClick={handleLinkClick}>Startup Studio</Link>
            <Link to="/contact-us" onClick={handleLinkClick}>Contact Us</Link>
            <Link to="/terms" onClick={handleLinkClick}>Terms & Conditions</Link>
            <Link to="/privacy-policy" onClick={handleLinkClick}>Privacy Policy</Link>
            <Link to="/refund-and-cancellation" onClick={handleLinkClick}>Refund & Cancellation</Link>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="flex flex-col md:flex-row items-center justify-between text-gray-400 text-sm pt-8 text-center md:text-left">
          {/* Left Text */}
          <span className="mb-2 md:mb-0">© {new Date().getFullYear()}</span>

          {/* Dotted Line */}
          <div className="hidden md:block flex-grow border-t border-dashed border-gray-400 mx-4"></div>

          {/* Right Text */}
          <span>All rights reserved by The Orcas Valley</span>
        </div>

        {/* Contact Information */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 pt-6 text-gray-300 text-sm">
          <div className="flex items-center gap-2">
            <FaMapMarkerAlt className="text-[#02C4A1]" />
            <span>London,UK</span>
          </div>
          <div className="hidden md:block h-4 w-px bg-gray-500"></div>
          <div className="flex items-center gap-2">
            <FaPhoneAlt className="text-[#02C4A1]" />
            <a href="tel:+447451250194" className="hover:text-[#02C4A1] transition-colors">
              +44 7 451250194
            </a>
          </div>
       
        </div>

        {/* Social Media & Network Partner Section */}
        <div className="flex flex-col md:flex-row items-center justify-between pt-8 gap-6">
          {/* Social Media Icons */}
          <div className="flex items-center gap-4">
            <a 
              href="https://www.f6s.com/orcas-valley-founder-cohort-winter-2026/apply" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
              aria-label="F6S"
            >
              <img src={f6sLogoWhite} alt="F6S" className="w-8 h-8" />
            </a>
            {/* Add other social media icons here as needed */}
                 <div className="ml-4 flex space-x-3">
            <a href="https://www.linkedin.com/company/orcas-valley" target="_blank" rel="noopener noreferrer" className="text-white-700 hover:text-[#02C4A1] transition-colors"><FaLinkedinIn className="w-5 h-5" /></a>
            </div>
          </div>

          {/* F6S Network Partner Badge */}
          {/* <div className="flex items-center justify-end">
            <a 
              href="https://www.f6s.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:opacity-90 transition-opacity"
            >
              <img 
                src={f6sNetworkPartnerWhite} 
                alt="F6S Network Partner" 
                className="h-16 w-auto"
              />
            </a>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
